import {
  TbTable,
  TbLayoutGrid,
  TbStack2,
  TbStack2Filled,
  TbSettings,
  TbPlus,
} from "react-icons/tb";
import { useState } from "react";
import { useMapContext } from "@/hooks/useMap";
import { useModalStore } from "@/stores/modalStore";
import { RoleGuard } from "@/components/auth";
import { AdminManagement } from "@/components/admin";

export const IconBar: React.FC = () => {
  const {
    tableVisible,
    setTableVisible,
    showBasemapSwitcher,
    setShowBasemapSwitcher,
  } = useMapContext();

  const closeAllModals = useModalStore((s) => s.closeAllModals);
  const [showAdminManagement, setShowAdminManagement] = useState(false);

  const handleAddTaskClick = () => {
    // Just trigger the add task workflow - all logic will be in MapPage/MapContext
    // This will be handled by MapPage listening to this event
    window.dispatchEvent(
      new CustomEvent("addTaskRequest", { detail: { source: "iconbar" } })
    );
  };

  return (
    <>
      <div className="absolute top-20 left-4 z-[1001] flex flex-col items-center justify-center gap-1 bg-white rounded-xl shadow-[0px_0px_24px_0px_rgba(0,0,0,0.08)] p-1">
        {/* Admin User Management Button */}
        <RoleGuard adminOnly>
          {(() => {
            return (
              <button
                onClick={() => {
                  closeAllModals();
                  setShowBasemapSwitcher(false);
                  setTableVisible(false);
                  setShowAdminManagement(true);
                }}
                className={`w-14 h-14 p-3.5 rounded-2xl inline-flex justify-center items-center gap-2.5 transition focus:outline-none ${
                  showAdminManagement
                    ? "bg-[#374795] text-white"
                    : "bg-white custom-text-gray-dark custom-text-dark-gray-hover hover:bg-gray-100 hover:cursor-pointer"
                }`}
                aria-label="Admin Management"
                title="Admin Management"
              >
                {showAdminManagement ? (
                  <TbSettings size={26} />
                ) : (
                  <TbSettings size={26} />
                )}
              </button>
            );
          })()}
        </RoleGuard>

        {/* Add Task Button */}
        <button
          onClick={handleAddTaskClick}
          className="w-14 h-14 p-3.5 rounded-2xl inline-flex justify-center items-center gap-2.5 transition focus:outline-none custom-text-gray-dark custom-text-dark-gray-hover bg-white hover:bg-gray-100 hover:cursor-pointer"
          aria-label="Add Task"
          title="Add New Task"
        >
          <TbPlus size={26} />
        </button>

        {/* Task Table Toggle */}
        <button
          onClick={() => setTableVisible((v) => !v)}
          className={`w-14 h-14 p-3.5 rounded-2xl inline-flex justify-center items-center gap-2.5 transition focus:outline-none ${
            tableVisible
              ? "bg-[#374795] text-white"
              : "bg-white custom-text-gray-dark custom-text-dark-gray-hover hover:bg-gray-100 hover:cursor-pointer"
          }`}
          aria-label={tableVisible ? "Hide Task Table" : "Show Task Table"}
          title={tableVisible ? "Hide Task Table" : "Show Task Table"}
        >
          {tableVisible ? <TbLayoutGrid size={26} /> : <TbTable size={26} />}
        </button>

        {/* Basemap Switcher */}
        <button
          onClick={() => setShowBasemapSwitcher((v: boolean) => !v)}
          className={`w-14 h-14 p-3.5 rounded-2xl inline-flex justify-center items-center gap-2.5 transition focus:outline-none ${
            showBasemapSwitcher
              ? "bg-[#374795] text-white"
              : "bg-white custom-text-gray-dark custom-text-dark-gray-hover hover:bg-gray-100 hover:cursor-pointer"
          }`}
          aria-label={
            showBasemapSwitcher
              ? "Hide Basemap Switcher"
              : "Show Basemap Switcher"
          }
          title={
            showBasemapSwitcher
              ? "Hide Basemap Switcher"
              : "Show Basemap Switcher"
          }
        >
          {showBasemapSwitcher ? (
            <TbStack2Filled size={26} />
          ) : (
            <TbStack2 size={26} />
          )}
        </button>
      </div>

      {/* Admin Management Modal */}
      <AdminManagement
        open={showAdminManagement}
        onClose={() => setShowAdminManagement(false)}
      />
    </>
  );
};
